import { LOADING_STATUSES } from '@yandex-int/k-common/client/api/constants';
import { SearchData } from '@yandex-int/k-common/typings';
import isEmpty from 'lodash/isEmpty';
import { reportMessage } from 'platform-components/utils';

import { LIBRARY_SEARCH_STATE, type SearchResults, type SearchFilters } from './typings';

/**
 * Парсит поиск по контенту
 *
 * @param res ответ бэка
 * @param filters определяет фильтры по предметам, если не указан – берем всё
 */
export const getLibrarySearchResults = (res: SearchData, filters?: SearchFilters): SearchResults => {
    const { subjects } = filters || {};

    return (
        res?.response?.results?.[0].groups?.reduce((acc: SearchResults, group) => {
            const document = group?.documents[0];
            const { url: themeId, properties } = document;
            const {
                s_subject_slug: subject,
                s_subject_name: subjectName,
                p_ru_theme_id_mapping: stringMapping,
            } = properties;

            if (subjects && !subjects.includes(subject)) {
                return acc;
            }

            try {
                const mapping = JSON.parse(stringMapping);
                const themeName = mapping[themeId];

                if (!acc[subject]) {
                    acc[subject] = {
                        subjectName,
                        results: [],
                    };
                }

                acc[subject].results.push({ themeId, themeName, subjectName });
            } catch (error) {
                console.error(error);
                reportMessage('Error while parsing search response:', error);
            }

            return acc;
        }, {}) || {}
    );
};

export const getSearchState = (
    query: string | null,
    result: SearchResults,
    loadingStatus: LOADING_STATUSES
): LIBRARY_SEARCH_STATE | null => {
    if (!query) {
        return LIBRARY_SEARCH_STATE.EMPTY;
    }

    if (loadingStatus === LOADING_STATUSES.LOADING) {
        return LIBRARY_SEARCH_STATE.LOADING;
    }

    if (loadingStatus === LOADING_STATUSES.SUCCESS && !isEmpty(result)) {
        return LIBRARY_SEARCH_STATE.LOADED;
    }

    const isNotFound = loadingStatus === LOADING_STATUSES.SUCCESS && isEmpty(result);

    if (loadingStatus === LOADING_STATUSES.ERROR || isNotFound) {
        return LIBRARY_SEARCH_STATE.NOT_FOUND;
    }

    return null;
};
